export const updateRacer = {
  bib_number: {
    length: {
      maximum: 5,
    },
  },
};
